import styled, { css } from 'styled-components';

export const FiltersContainer = styled.div<{ isHidden: boolean; searchError: boolean; searchTerm: boolean }>`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 45%;
  min-width: 300px;
  max-width: 410px;
  ${({ searchTerm, theme }) =>
    searchTerm &&
    css`
      fuel-icon:first-child {
        cursor: pointer;
        margin-right: ${theme.spacing.km4};
        padding-right: ${theme.spacing.km4};
        border-right: ${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.border.neutral.default};
      }
    `}
  ${({ isHidden }) =>
    !isHidden &&
    css`
      fuel-text-field {
        margin-right: ${({ theme }) => theme.spacing.km4};
      }
    `}
    div {
    display: flex;
  }

  span {
    display: ${({ searchError }) => (searchError ? 'inline' : 'none')};
    color: ${({ theme }) => theme.color.text.danger.default};
    font-size: ${({ theme }) => theme.font.size.m2};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding-top: ${({ theme }) => theme.spacing.km3};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    width: 100%;
  }
`;
